import { FunctionComponent } from "react";
import Header from "./headers/Header";
import Footer from "./footers/Footer";

type LayoutProps = {
  children: JSX.Element;
};

const Layout: FunctionComponent<LayoutProps> = ({ children }: LayoutProps) => {
  return (
    <div className="bg-white">
      <Header />
      <div className="container mx-auto">
        {children}
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
